export const track = (event: string, properties = {}) => {
  const global = window as any;
  if (global["mixpanel"]) {
    global["mixpanel"].track(event, properties);
  } else {
    // investigate creating a backlog of mixpanel events to create in case it gets loaded after the scripts runs
    if (!global["mixpanel_events"]) {
      global["mixpanel_events"] = [];
    }
    global["mixpanel_events"].push({
      event,
      properties
    });
  }
};
